// extracted by mini-css-extract-plugin
export default {"completed-icon":"BJbpY7","completedIcon":"BJbpY7","onboarding":"JUnrJz","prior":"qZixkm","displayOnTablet":"Dm_X5t","topics":"ZGLM0W","filters":"aVvaCm"};